import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-application-view',
  templateUrl: './application-view.component.html',
  styleUrl: './application-view.component.scss'
})
export class ApplicationViewComponent {
  AppID: string;
  ModuleID: string;
  constructor(
    private route: ActivatedRoute,
    private commonService: CommonService,
  ) {
    this.AppID = route.snapshot.params['appid'];
    this.ModuleID = route.snapshot.params['moduleid'];
  }
  ngOnInit() {
    switch (this.ModuleID) {
      case "2":
        this.commonService.ViewApplicationPage(this.AppID, "ist", "");
        break;
      case "4":
        this.commonService.ViewApplicationPage(this.AppID, "grants", "");
        break;
      case "5":
        this.commonService.ViewApplicationPage(this.AppID, "eap", "");
        break;
    }
  }
}
